import { css } from '@emotion/css';
import { colors, themeParser, useAppTheme } from '@/theme';

interface GeneralTabStyles {
  tabItems: string;
  tabItem: string;
  tabText: string;
  active: string;
}

export const useGeneralTabStyles = (numberOfTabs: number): GeneralTabStyles => {
  const theme = useAppTheme();

  return {
    tabItems: css`
      background: ${themeParser('#eeeeee', colors.tabItem.dark, theme)};
      margin: 0;
      padding: 0;
      line-height: 45px;
      box-shadow:
        0 2px 2px 0 rgb(0 0 0 / 14%),
        0 3px 1px -2px rgb(0 0 0 / 12%),
        0 1px 5px 0 rgb(0 0 0 / 20%);
    `,
    tabItem: css`
      display: inline-flex;
      text-align: center;

      padding: 0;
      margin: 0;
      width: calc(100% / ${numberOfTabs});
      margin-left: auto;
      left: auto;
      right: auto;
      height: 100%;
      @media (max-width: 1140px) {
        min-width: 16.2%;
        width: auto;
      }
      @media (max-width: 1019px) {
        min-width: 24.999999999%;
      }
      @media (max-width: 767px) {
        min-width: 24.999999999%;
        line-height: 38px;
        height: 38px;
      }
      @media (max-width: 600px) {
        min-width: 50%;
      }
    `,
    tabText: css`
      color: ${themeParser(colors.tabText.light, colors.tabText.dark, theme)};
      border-bottom: none;
      border-left: 1px solid ${themeParser('#e0e0e0', colors.borderLeftColor.dark, theme)};
      display: block;
      width: 100%;
      height: 100%;
      padding: 0 24px;
      font-size: 14px;
      cursor: pointer;
      transition: color .28s ease, background-color .28s ease;
      @media (max-width: 767px){
        padding: 0 14px;
        font-size: 12px;
      }
      :hover {
        color: ${themeParser('#000000', colors.tabTextActive.dark, theme)};
        font-weight: 600;
      },
    `,
    active: css`
      color: ${themeParser('#000000', colors.tabTextActive.dark, theme)} !important;
      font-weight: 600;
      font-size: 15px;
    `,
  };
};
